import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ThemeService } from '../../../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-pix-withdraw-change-help',
	templateUrl: './help.component.html',
	styleUrls: ['./help.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixWithdrawChangeHelpComponent implements OnInit {

	phoneCrCapital = '4004 3500';
	phoneCrMore = '0800 701 3500';
	phoneSAC = '0800 727 0885';

	constructor(
		private themeService: ThemeService
	) {}

	ngOnInit(): void {
		this.definePhonesByTheme();
	}

	definePhonesByTheme() {
		switch (this.themeService.currentURL) {
			case 'www.powerclub.com.br':
				this.phoneCrCapital = '4003 0583';
				this.phoneCrMore = '0800 770 6301';
				this.phoneSAC = '0800 770 6302';
				break;
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/faq/help/help.component.ts